import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createElement } from 'react';
import { ksdpRiskReadPermission } from '@internal/ksdp-permissions-common';
import { guardKsdpPage } from '@internal/ksdp-permissions-react';
import { RiskLibraryPage } from './components/RiskLibraryPage';
import { CustomRiskLibraryIcon } from './icons/RiskLibraryIcon';

const riskLibraryPage = PageBlueprint.make({
  name: 'risk-library',
  params: {
    path: '/risk-library',
    title: 'Risk Library',
    icon: createElement(CustomRiskLibraryIcon),
    loader: async () =>
      guardKsdpPage(ksdpRiskReadPermission, createElement(RiskLibraryPage)),
  },
});

export const riskLibraryPlugin = createFrontendPlugin({
  pluginId: 'risk-library',
  extensions: [riskLibraryPage],
});
